<div class="aig-home">
  <!-- <aig-cookies-modal></aig-cookies-modal> -->
  <aig-hero [info]="heroInfo"></aig-hero>
  <section class="aig-home__section">
    <div class="o-container">
      <div class="row">
        <div class="col-12 col-sm-12 col-lg-12 col-xl-12">
          <div class="aig-home__content">
            <div class="row">
              <div class="col-12">
                <aig-textgroup></aig-textgroup>
              </div>
            </div>
            <div class="u-clearfix--height-100"></div>
            <div class="row">
              <div class="col-12">
                  <aig-link></aig-link>
              </div>
            </div>
            <div class="u-clearfix--height-100"></div>
            <div class="row">
              <div class="col-12 u-mb-5">
                <h2 class="u-color-primary1 u-fs-40 u-fw-500"> Preguntas frecuentes </h2>
              </div>
              <div class="col-12">
                <aig-accordion [items]="Faqs" prefix="faqs-" ></aig-accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>